import React, { Component } from "react";
import { Box, Typography, Button, Divider,Select,FormControl,MenuItem } from '@mui/material';


const ext1 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ext-0001.webp?alt=media&token=cf29f486-f60e-451c-b09c-947e9e76fa12"
const ext2="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ext-0006.jpg?alt=media&token=237633af-c6f5-4ade-a27f-f56d7f1d3066"
const ext3 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ext-0004%20(1).webp?alt=media&token=187944e1-5e54-4253-807c-c18676114511"
const ext4 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ext-0002.webp?alt=media&token=1e7d0d70-c088-46dc-a31b-702e7092e044"
 
const int1 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-int-0005.webp?alt=media&token=333c0ba4-9a52-4139-9463-fca5084bb910"
const int2 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-int-0012.webp?alt=media&token=7c71e47d-3284-457f-a3c2-1ac321b7db64"
const int3 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-int-0004.webp?alt=media&token=cfed277f-5c79-4072-bfe6-e6ef534c8a80"
const int4 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-int-0003.webp?alt=media&token=3ab22dd4-b2ec-44e6-9049-152d92ff6ed4"

const safe1 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-saf-0010%20(1).webp?alt=media&token=927e536c-968e-475d-909f-de6139da585e"
const safe2 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-saf-0012.webp?alt=media&token=bdb4082c-93c9-4ef8-8904-53a305e98dfa"
const safe3 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-saf-0005.webp?alt=media&token=6c51b684-ff2d-43f2-8170-0403e988922a"
const safe4 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-saf-0010.webp?alt=media&token=f3acd204-d9f2-485d-8d4c-49aa2ceff384"

const adas1 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ads-0004.webp?alt=media&token=bb98cea5-4094-4aa8-959b-430685f7028e"
const adas2="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ads-0007.webp?alt=media&token=91b969d0-e539-46e4-88b0-119807f35430"
const adas3 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ads-0001.webp?alt=media&token=16d2f299-8edd-4750-bd38-1c7947939562"
const adas4 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ads-0003.webp?alt=media&token=0d84b9f5-57c1-4619-a972-6ab88be09b0e"

const i1 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ism-0012.webp?alt=media&token=ee6af56c-1edf-4ed6-ba04-dc77e3da3d32"
const i2 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ism-0002.webp?alt=media&token=1738b854-6018-4795-9220-c7b6a250d56a"
const i3 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ism-0004.webp?alt=media&token=e4192f13-31c5-49c2-af7d-2fe00fbdf2ce"
const i4 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-ism-0008.webp?alt=media&token=86db892f-3f8a-4939-973f-adcbf15e5639"

const comf1 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-com-0004.webp?alt=media&token=4c10448a-91ac-4565-93ff-c2b2c571b6f2"
const comf2 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-com-0001.webp?alt=media&token=6432f2f1-0f93-4cfb-a9f6-b1b23a6dccc7"
const comf3 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-com-0006.webp?alt=media&token=841b76e4-8baa-4522-8af9-74643eabce64"
const comf4 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-hector%2Fmgi-hector-com-0005.webp?alt=media&token=44dd3c3b-b719-4785-8675-950c7380eea0"

// const ser1 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Hector%2FSERVICES%2Fshield1.webp?alt=media&token=aa59094e-2d1f-4790-aa2c-e882a7fafe2f"
// const ser2="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Hector%2FSERVICES%2Fsheild2.webp?alt=media&token=6600bb52-fcb3-4724-aca6-b16d6daf5a19"
// const ser3 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Hector%2FSERVICES%2Fsheild3.webp?alt=media&token=087c89ed-82b6-4aee-958c-de36445712fc"


class Features extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 'EXTERIOR',
      isMobile: window.innerWidth <= 900, // Detect initial mobile view
      selectedImage: this.getTabImages('EXTERIOR')[0], 
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };


  getTabImages = (tab) => {
    const tabData = {
      EXTERIOR: [
        {
          src: ext1,
          label:'AURA-HEX GRILLE',
          title: 'AURA-HEX GRILLE',
          subtitle: 'DESIGNED TO OUTSHINE',
          description: 'The striking Aura-Hex Grille gives the all-new Hector a powerful, modern face.Precision geometry meets road-owning presence for a magnificent arrival.',
        },
        {
          src: ext2,
          label:'AURA BOLT ALLOY WHEELS',
          title: 'AURA BOLT ALLOY WHEELS',
          subtitle: 'DESIGNED TO OUTSHINE',
          description: 'The Aura Bolt Alloys add a bold, energetic stance to every drive.Crafted for stability, styled for admiration on the move.',
        },
        {
          src: ext3,
          label: 'AURA SCULPT BUMPERS',
          title:'AURA SCULPT BUMPERS',
          subtitle: 'DESIGNED TO OUTSHINE',
          description: 'The sculpted bumpers enhance width, character and road presence.Dynamic, refined, and built to make the all-new Hector look sculpted for a stronger, charismatic look. ',
        },
        {
          src: ext4,
          label: 'LED CONNECTED TAIL LIGHTS',
          title:'LED CONNECTED TAIL LIGHTS',
          subtitle: 'DESIGNED TO OUTSHINE',
          description: 'The LED Connected Tail Lamps create a seamless, modern rear signature.Bright, cohesive, and instantly recognisable even from a distance.',
        }
      ],
      INTERIOR: [
        {
          src: int1,
          label:'INDIA’S LARGEST-IN-CLASS 35.56 CM (14 INCH) HD PORTRAIT SCREEN INFOTAINMENT SYSTEM',
          title: 'INDIA’S LARGEST-IN-CLASS 35.56 CM (14 INCH) HD PORTRAIT SCREEN INFOTAINMENT SYSTEM',
          subtitle: 'DESIGNED TO LOOK PREMIUM, FEEL PLUSH',
          description: 'A screen this big deserves smarter control. India’s largest HD screen now comes with segment’s first gesture control bringing convenience to every drive.',
        },
        {
          src: int2,
          label:'DUAL TONE ICE GREY INTERIORS (5 SEATER)',
          title: "DUAL TONE ICE GREY INTERIORS (5 SEATER)",
          subtitle: 'DESIGNED TO LOOK PREMIUM, FEEL PLUSH',
          description: 'The Ice Grey interior creates a bright, spacious, modern cabin.A soothing palette that elevates everyday drives into an impeccable experience. ',
        },
        {
          src: int3,
          label:'DUAL TONE URBAN TAN INTERIORS (6 & 7 SEATER)',
          title: 'DUAL TONE URBAN TAN INTERIORS (6 & 7 SEATER)',
          subtitle: 'DESIGNED TO LOOK PREMIUM, FEEL PLUSH',
          description: 'The Urban Tan palette brings a premium, sophisticated warmth to the cabin, creating exceptional indulgence.',
        },
        {
          src: int4,
          label:'DUAL PANE PANORAMIC SUNROOF',
          title: 'DUAL PANE PANORAMIC SUNROOF',
          subtitle: 'undefined',
          description: 'The expansive and enchanting dual pane panoramic sunroof floods the cabin with light and openness.Feel the sky, the breeze, and a sense of limitless freedom. ',
        }
      ],
      SAFETY: [
        {
          src: safe1,
          label:'360 AROUND VIEW (HD) CAMERA SYSTEM WITH WHEEL VIEW',
          title: '360 AROUND VIEW (HD) CAMERA SYSTEM WITH WHEEL VIEW',
          subtitle: 'DESIGNED TO KEEP YOUR SECURE',
          description: 'The 360* Around View HD Camera System with Wheel View lets you see precisely what’s around your wheels.Navigate tight spaces, obstacles, and parking spots with complete confidence.​',
        },
        {
          src: safe2,
          label:'STEEL BODY',
          title: 'STEEL BODY',
          subtitle: 'DESIGNED TO KEEP YOUR SECURE',
          description: 'With its rugged high-strength built and a host of advanced safety features, the all-new Hector is designed to absorb, shield and protect. It’s toughness with purpose, ensuring confidence and calm for everyone inside.',
        },
        {
          src: safe3,
          label: 'ELECTRIC PARKING BRAKE (CVT)',
          title:'ELECTRIC PARKING BRAKE (CVT)',
          subtitle: 'DESIGNED TO KEEP YOUR SECURE',
          description: 'The Electric Parking Brake activates smoothly at the push of a button.Designed to hold your ground safely.Effortless, reliable and intelligent – safety that fits seamlessly into your drive. ',
        },
        {
          src: safe4,
          label: '360 AROUND VIEW (HD) CAMERA SYSTEM',
          title:'360 AROUND VIEW (HD) CAMERA SYSTEM',
          subtitle: 'DESIGNED TO KEEP YOUR SECURE',
          description: 'The all-new Hector’s advanced safety ensures intelligent protection at every turn – backed by technology that’s always looking out for you. Because true confidence begins with feeling secure. ',
        }
      ],
      ADAS: [
        {
          src: adas1,
          label:'ADAS AUTONOMOUS LEVEL 2',
          title: 'ADAS AUTONOMOUS LEVEL 2',
          subtitle: 'DESIGNED TO KEEP YOUR SECURE',
          description: 'All-new Hector is built with one thing in mind – to raise your driving experience and safety with the most cutting-edge technology on offer.  The 11 Autonomous Level-2 features of the Advanced Driver Assistance System (ADAS) are a giant leap in this direction, which keep an eye out for you at every turn and straight. ',
        },
        {
          src: adas2,
          label:'ADAPTIVE CRUISE CONTROL (ACC)',
          title: "ADAPTIVE CRUISE CONTROL (ACC)",
          subtitle: 'DESIGNED TO KEEP YOUR SECURE',
          description: 'Adaptive Cruise Control senses and monitors the road ahead and automatically accelerates or decelerates for maintaining a proper distance from the vehicle in front. Thanks to the Bend Cruise Assistance (BCA), the vehicle automatically decelerates when entering a curve based on your driving speed and curve radius.',
        },
        {
          src: adas3,
          label:'Traffic Jam Assist (TJA)',
          title: 'TRAFFIC JAM ASSIST (TJA)',
          subtitle: 'DESIGNED TO KEEP YOUR SECURE',
          description: 'Traffic Jam Assist (TJA) works in conjunction with ACC and LKA to let you cruise through heavy traffic with complete safety and comfort. By keeping the vehicle in middle of the lane and maintaining a safe distance from the vehicle in front, it takes you through jams securely and comfortably.',
        },
        {
          src: adas4,
          label:'Lane Departure Warning (LDW)',
          title: 'LANE DEPARTURE WARNING (LDW)',
          subtitle: 'DESIGNED TO KEEP YOUR SECURE',
          description: 'If, the vehicle is ‘unintentionally’ deviating from its lane without giving an indicator, to keep you inside the lane, the Lane Departure Warning (LDW) function identifies lane markings on the road and warns the driver through visual and acoustic signals or steering wheel vibrations to ensure you stay inside the lane.',
        }
      ],
      "i-SMART": [
        {
          src: i1,
          label:'I-SWIPE TOUCH GESTURE CONTROL',
          title: 'I-SWIPE TOUCH GESTURE CONTROL',
          subtitle: 'DESIGNED TO MAKE EVERY COMMAND EFFORTLESS',
          description: 'Innovation designed around convenience with segment’s first Gesture Control.Adjust AC temperature, fan speed, music, and volume with intuitive hand swipes.No buttons, no distractions. Just seamless control. ',
        },
        {
          src: i2,
          label:'DIGITAL BLUETOOTH CAR KEY',
          title: 'DIGITAL BLUETOOTH CAR KEY',
          subtitle: 'DESIGNED TO MAKE EVERY COMMAND EFFORTLESS',
          description: 'Use your phone as your key with secure Bluetooth access.Walk in, start up, and drive. ',
        },
        {
          src: i3,
          label: '70+ CONNECTED CAR FEATURES',
          title:'70+ CONNECTED CAR FEATURES',
          subtitle: 'DESIGNED TO MAKE EVERY COMMAND EFFORTLESS',
          description: 'Designed to keep you connected to your car.Control, monitor, and manage the all-new Hector from anywhere.Advanced connected features that bring true smart mobility. ',
        },
        {
          src: i4,
          label: '100+ VOICE COMMANDS',
          title:'100+ VOICE COMMANDS',
          subtitle: 'DESIGNED TO MAKE EVERY COMMAND EFFORTLESS',
          description: 'Navigate, play music, adjust settings – all you have to do is just say the word.Over 100 voice commands and 30+ Hinglish voice commands that make driving hands-free and easy.',
        }
      ],
      COMFORT: [
        {
          src: comf1,
          title:'AUTOMATIC POWERED TAILGATE',
          subtitle: 'DESIGNED TO BE YOUR SAFE SPACE',
          label: 'AUTOMATIC POWERED TAILGATE',
          description: 'Your all-new Hector is always ready to assist.The automatic powered tailgate lets you access the boot space with effortless ease. ',
        },
        {
          src: comf2,
          label:'FRONT VENTILATED SEATS',
          title: "FRONT VENTILATED SEATS",
          subtitle: 'THOUGHTFULLY DESIGNED FOR UNRIVALLED COMFORT',
          description: 'Designed to make long drives breezy and soothing.Stay refreshed, relaxed, and ready for every journey. ',
        },
        {
          src: comf3,
          label:'AIR PURIFIER WITH PM 2.5 FILTER',
          title: 'AIR PURIFIER WITH PM 2.5 FILTER',
          subtitle: 'THOUGHTFULLY DESIGNED FOR UNRIVALLED COMFORT',
          description: 'Advanced filtration that keeps dust and pollutants at bay and gives you cleaner air on every drive.Every breath feels cleaner, lighter, and healthier inside.  ',
        },
        {
          src: comf4,
          label:'6-WAY POWER ADJUST DRIVER SEAT',
          title: '6-WAY POWER ADJUST DRIVER SEAT',
          subtitle: 'THOUGHTFULLY DESIGNED FOR UNRIVALLED COMFORT',
          description: 'With 6 powered adjustments, find your ideal driving posture easily. Comfort tailored to you, every time you take the wheel.  ​',
        }
      ],
      // SERVICE: [
      //   {
      //     src: ser1,
      //     label:'Personalised Ownership Package',
      //     title: 'PESONALISED OWNERSHIP PACKAGE',
      //     subtitle: 'A COMPLETE CARE PACKAGE',
      //     description: 'The MG Shield gives you 65+ combinations to choose from. This helps you pick the kind of assistance that best suits your ownership experience. ',
      //   },
      //   {
      //     src: ser2,
      //     label:'MG Shield',
      //     title: 'MG SHIELD',
      //     subtitle: 'A COMPLETE CARE PACKAGE',
      //     description: ['The 3-3-3 MG Shield package gives you',
      //       ' 3 years unlimited Km warranty',
      //       ' 3 years unlimited Km roadside assistance',
      //       ' 3 free labour services'],
      //   },
      //   {
      //     src: ser3,
      //     label: 'Sunroof Touch Control',
      //     title:'SUNROOF TOUCH CONTROL',
      //     subtitle: 'TECHNOLOGY THAT EMPOWERS YOU',
      //     description: 'Have the best views at your fingertips. Conveniently set the percentage opening limit of your Next-Gen Hector’s sunroof, between 0% to 100%, directly from the touchscreen!',
      //   },
        
      // ],
    };
    
    return tabData[tab] || [];
  };

  handleTabChange = (tab) => {
    const images = this.getTabImages(tab);
    this.setState({
      selectedTab: tab,
      selectedImage: images[0], // Default to first image of the selected tab
    });
  };

  handleImageClick = (image) => {
    this.setState({ selectedImage: image });
  };

  renderContent = () => {
    const { selectedTab, selectedImage } = this.state;
    const images = this.getTabImages(selectedTab);
  
    return (
      <Box sx={{ width: '80%', height: { md: '100%', xs: '100%', sm: '100%',lg:'100%'},
      }}>
        <Box
          sx={{
            height:'90%',
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: { xs: 'center', md: 'space-around' },
            alignItems: { xs: 'center', md: 'start' },
            gap: '20px',
            flexWrap: 'no-wrap',
            marginLeft: { xs: '-5px', md: '0px' },
            
          }}
        >
          <img
            src={selectedImage.src}
            style={{
              borderRadius: '10px',
              width: '97vw',
              maxWidth: '500px',
              height: 'auto',
            }}
            alt={selectedImage.title}
          />
  
          <style>
            {`
              @media (max-width: 768px) { /* Tablet and smaller */
                img {
                  width: 80vw; /* Adjust the width for tablet view */
                  max-width: 100%; /* Ensure it doesn't exceed container width */
                }
              }
  
              @media (max-width: 480px) { /* Mobile view */
                img {
                  width: 90vw; /* Increase width for mobile view */
                  max-width: 100%;
                }
              }
            `}
          </style>
  
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: { md: 'space-around', xs: 'start', sm: 'start' },
              alignItems: 'start',
              width: '100%',
              maxWidth: '500px',
              marginLeft: { xs: '-25px', md: '0px' }
            }}
          >
            <Typography
              variant="h5"
              sx={{
                width: { xs: '90%', md: '510px' },
                fontFamily: 'GillSansRegular, Arial, sans-serif',
                color: '#000',
                fontSize: { xs: '4vw', md: '1.5625vw' },
                marginBottom: '12px',
              }}
            >
              {selectedImage.title}
            </Typography>
            <Typography
              sx={{
                width: { xs: '90%', md: '330px', sm: '90%' },
                fontFamily: 'Roboto-Regular, Arial, sans-serif',
                color: '#6e6e6e',
                fontSize: { xs: '3.5vw', md: '1.04167vw', sm: '2.5vw' },
                marginBottom: '12px',
              }}
            >
              {selectedImage.subtitle}
            </Typography>
            <Typography
              sx={{
                width: { xs: '100%',sm:'80%' ,md: '90%', lg: '90%' },
                fontFamily: 'Roboto-Regular, Arial, sans-serif',
                fontSize: { xs: '3.5vw', md: '1.04167vw', sm: '2.1vw' },
                color: '#000',
                marginBottom: '2.08333vw',
                paddingTop: '1.30208vw',
                '@media (min-width: 1024px) and (max-width: 1139px)': {
                  width: '280px',
                },
              }}
            >
              {selectedImage.description}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: { xs: 'center', md: 'flex-start' },
            gap: '10px',
            marginTop: { xs: '10px', md: '50px', lg: '20px' },
            marginLeft: { xs: '-10px', md: '0px' },
          }}
        >
          {images.map((img, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: { md: 'center', xs: 'start' }
              }}
            >
              <img
                src={img.src}
                style={{
                  borderRadius: '10px',
                  width: '20vw',
                  maxWidth: '250px',
                  height: 'auto',
                  marginTop: { xs: '10px', md: '40px', sm: '20px' }
                }}
                alt={img.label}
                onClick={() => this.handleImageClick(img)}
              />
              <Typography
                sx={{
                  fontFamily: 'Roboto-Medium, Arial, sans-serif',
                  fontSize: { xs: '3.5vw', md: '1.04167vw' },
                  color: '#000',
                  paddingTop: '1.04167vw',
                  margin: 0,
                  fontWeight: '550',
                  display: { md: 'flex', xs: 'none' },
                  textAlign: { xs: 'none', md: 'left' },
                  width: '100%'
                }}
              >
                {img.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };
  


  render() {
    const { selectedTab, isMobile } = this.state;
    const tabs = ['EXTERIOR', 'INTERIOR', 'SAFETY', 'ADAS', 'i-SMART', 'COMFORT', ];

    return (
      <Box
        id="features"
        sx={{
          height: 'auto',
          width: '100%',
          // minHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '6vw', md: '2.08333vw' }, 
            color: '#cf2230',
            fontFamily: 'GillSansSemiBold, Arial, sans-serif',
            paddingBottom: '3.125vw',
            fontWeight: '400',
            marginTop:'20px'
          }}
        >
          A Car That Has It All
        </Typography>

        {isMobile ? (
          <FormControl fullWidth sx={{ width: '80%', marginBottom: '20px', }}>
            <Select
              value={selectedTab}
              style={{fontWeight:'700'}}
              onChange={(e) => this.handleTabChange(e.target.value)}
              displayEmpty
              inputProps={{ 'aria-label': 'Tab Selection' }}
            >
              {tabs.map((tab) => (
                <MenuItem key={tab} value={tab}>
                  {tab}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <Box
            sx={{
              height: '15px',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '50px',
            }}
          >
            {tabs.map((tab) => (
              <Button
                key={tab}
                onClick={() => this.handleTabChange(tab)}
                sx={{
                  fontFamily: 'GillSansRegular, Arial, sans-serif',
                  fontSize: { xs: '4vw', md: '1.25vw' }, 
                  color: selectedTab === tab ? 'white' : 'black',
                  backgroundColor: selectedTab === tab ? '#E32735' : 'transparent',
                  '&:hover': {
                    backgroundColor: '#E32735',
                    color: 'white',
                  },
                }}
              >
                {tab}
              </Button>
            ))}
          </Box>
        )}

        <Divider sx={{ width: '80%', display:{md:'flex',xs:'none'},border: '4px solid #E32735', margin: '20px 0' }} />

        {this.renderContent()}

        {/* <Button
          sx={{
            backgroundColor: '#CF2230',
            color: 'white',
            fontWeight: '700',
            fontFamily: 'GillSansSemiBold , sans-serif',
            fontSize: { xs: '3.5vw', md: '0.95vw',sm:'2.2vw' }, 
            cursor: 'pointer',
            marginTop:'30px',
            '&:hover': {
              backgroundColor: 'black',
              color: 'white',
            },
          }}
        >
          Virtual Showroom
        </Button> */}
      </Box>
    );
  }
}

export default Features;
